import { getEventID } from 'app/lib/utils/adaya/AdayaUtils';
import CampaignHelper from 'helpers/CampaignHelper';
import { formatCurrency } from 'lib/utils/currency';
import { DATE_FORMAT, tzDate } from 'lib/utils/DateUtils';
import moment from 'moment-timezone';
import React, { useEffect, useRef, useState } from 'react';
import Pagination from './Pagination/Pagination';
import './style.scss';

export default TableBody = ({ eventsData, accountTimezone, showJourney }) => {

    const topRef = useRef()
    const [page, setPage] = useState(1)
    const scrollToTop = () => {
        topRef.current.scrollIntoView({ behavior: "smooth" })
    }

    useEffect(() => {
        scrollToTop()
    }, [page])

    const rowsPerPage = 40;
    const totalPages = eventsData?.length ? (Math.floor(eventsData.length / rowsPerPage) + 1) : 1
    const startingNum = (page * rowsPerPage) - rowsPerPage
    const endingNum = (page * rowsPerPage) - 1
    const totalNum = eventsData?.length ? eventsData.length : 0

    let dataDisplay = [];
    for (let i = startingNum; i < eventsData?.length && i <= endingNum; i++) {
        const thisData = eventsData[i]
        const orderDate = tzDate(thisData.orderDate || thisData.created, accountTimezone);
        const formattedDate = orderDate.format(DATE_FORMAT)
        const dateStr = moment.utc(thisData.date).format('MM-DD-yyyy')
        const totalPrice = formatCurrency(thisData.price, 2)
        const campaignName = CampaignHelper.lookupCampaignName(thisData.utm_campaign, thisData.utm_source);

        const columns = [
            { data: dateStr, title: dateStr, width: 1, color: 'grey' },
            { data: thisData.price, title: totalPrice, width: 1, color: 'green' },
            { data: thisData.email, title: thisData.email, width: 2, color: 'grey' },
            { data: campaignName, icon: thisData.utm_source, title: campaignName, width: 3, color: 'grey' },
            // {data: thisData.utm_campaign, icon: thisData.utm_source, title: thisData.utm_campaign, width: 3, color: 'grey'},
            // {data: thisData.price, title: 'Last Source', width: 3, color: 'grey'},
            { data: thisData, title: 'Show Journey', width: 2, color: 'blue' },
        ]

        const columnDisplay = columns.map((col, j) => {

            if (col.title !== 'Show Journey') {
                const thisIcon = col.icon ?
                    col.icon === 'fb' ? 'static/icons/user-journeys/facebook_01.svg' :
                        col.icon === 'ig' ? 'static/icons/user-journeys/instagram_01.svg' :
                            col.icon === 'google' ? 'static/icons/user-journeys/google_01.svg'
                                : null : null
                return (
                    <div key={`${i}_${j}`} className={`table-body-col ${col.width === 2 ? 'wide-2' : col.width === 3 ? 'wide-3' : ''}`}>
                        {thisIcon && (
                            <img src={thisIcon} className={`table-body-icon`} />
                        )}

                        <h2 className={`table-body-font ${col.color === 'grey' ? 'table-body-grey' : col.color === 'green' ? 'table-body-green' : col.color === 'blue' ? 'table-body-blue' : ''}`}>
                            {col.title}
                        </h2>
                    </div>
                )
            } else {
                return (
                    <div key={`${i}-${j}`} className={`table-body-col centered-col ${col.width === 2 ? 'wide-2' : col.width === 3 ? 'wide-3' : ''}`}>
                        <button
                            className={`table-body-font table-body-btn ${col.color === 'blue' ? 'table-body-blue' : ''}`}
                            onClick={() => showJourney(col.data)}
                        >
                            {col.title}
                        </button>
                    </div>
                )
            }

        })

        dataDisplay.push(
            <div key={i} className={`table-body-row`} id={getEventID(thisData)}>
                {columnDisplay}
            </div>
        )
    }

    return (
        <>
            <div className={`table-body-main`} ref={topRef}>
                {dataDisplay}
            </div>
            {totalPages > 0 && (
                <Pagination
                    startingNum={startingNum}
                    endingNum={endingNum}
                    totalNum={totalNum}
                    page={page}
                    totalPages={totalPages}
                    setPage={setPage}
                />
            )}
        </>
    )
}